import { api } from "../api/api";

export const movimentacaoProcessualService = {
  listarPorProcesso: async (
    processoId,
    pagina = 1,
    limite = 10
  ) => {
    const { data } = await api.get(
      `/movimentacaoprocessual/processo/${processoId}`,
      {
        params: {
          pagina,
          limite
        }
      }
    );

    return data;
  },

  buscarPorId: async (id) => {
    const { data } = await api.get(
      `/movimentacaoprocessual/${id}`
    );

    return data;
  },

  // ADICIONADO: Atualização apenas da data de vencimento da movimentação
  atualizarDataVencimento: async (id, dataVencimento) => {
    const { data } = await api.patch(
      `/movimentacaoprocessual/${id}`,
      { dataVencimento }
    );

    return data;
  },

  // 🟢 ADICIONADO: Atualização independente do status de cumprimento
  atualizarCumprido: async (id, cumprido) => {
    const { data } = await api.patch(`/movimentacaoprocessual/${id}`, {
      cumprido
    });
    return data;
  }
};